import styled from 'styled-components';

export const PageWrapStyles = styled.div`
  position: relative;
  width: calc(100% - 20px);
  max-width: 840px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  background: #f0f0f0;
  border-radius: 8px;
  padding: 10px;
`;
